import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9577e0b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drawer-list-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "drawer-list-header"
}
const _hoisted_4 = { class: "drawer-list-header-title text-ellipsis" }

import {computed, onMounted, PropType, ref, toRaw, watch, watchEffect} from "vue";
import {AppConfigComponent, AppConfigComponentListStyle} from "@/model/AppConfig";

import {useRouter} from "vue-router";
import AppConfigComponentDrawerDatasourceComponent from "./AppConfigComponentDrawerDatasourceCom.vue";
import {InfiniteScrollWay} from "@/views/appconfig/drawer/InfiniteScrollWay";


const __default__ = {
  name: "AppConfigComponentDrawerListComponent"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  component: {
    type: Object as PropType<AppConfigComponent>,
    required: true
  },
  numberPerRow: {
    type: Number,
    required: false,
    default: 4
  },
  // 是否是最后一个组件
  isLastComponent: {
    type: Boolean,
    required: false,
    default: false
  },
},
  setup(__props) {

const props = __props



const router = useRouter()
const goResourceView = (id: string) => {
  if (id) {
    const {href} = router.resolve({
      path: `/resources/${id}`
    })
    window.open(href)
  }
}

const goMoreView = (datasourceId: string, listStyle: AppConfigComponentListStyle) => {

  if (datasourceId) {
    const {href} = router.resolve({
      path: `/datasources/${datasourceId}`,
      query: {
        listStyle
      }
    })
    window.open(href)
  }
}

onMounted(async () => {

})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.component.list && __props.component.list.datasource)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (__props.component.list.showHeader)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(__props.component.list.name), 1),
                (__props.component.list.showMore)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (goMoreView(__props.component.list.datasource.id!,__props.component.list.style!))),
                      style: {"cursor":"pointer"},
                      class: "font-assistant secondary-text"
                    }, "更多"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (__props.component.list.datasource?.id)
            ? (_openBlock(), _createBlock(AppConfigComponentDrawerDatasourceComponent, {
                key: 1,
                "list-style": __props.component.list?.style,
                datasource: __props.component.list!.datasource!,
                "number-per-row": __props.numberPerRow,
                length: __props.component.list?.limitNumber!,
                "infinite-scroll": __props.component.list.limitNumber === 0,
                "infinite-scroll-way": __props.isLastComponent ? _unref(InfiniteScrollWay).PAGINATION : _unref(InfiniteScrollWay).CLICK
              }, null, 8, ["list-style", "datasource", "number-per-row", "length", "infinite-scroll", "infinite-scroll-way"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})